import React, { Component } from 'react';
import ReactLoading from 'react-loading';
import tr from '../../../libs/tr';
import './WaitLoad.css';

class WaitLoad extends Component {

    constructor(props) {

        super(props);

        this.enable = props.enable ? props.enable : false;
        this.state = {
            enable: false,
        }
    }

    componentWillReceiveProps(nextProps) {
        const { enable } = nextProps;
        this.setState({ enable });
    }

    render() {
        return (
            <div style={{ flex: 1 }}>
                {this.state.enable ?
                    <div className="containerLoading">
                        <ReactLoading className="loading" type={'bars'}/>
                    </div> : null
                }
            </div>
        );
    }
}

export default WaitLoad;



// WEBPACK FOOTER //
// ./src/assets/components/loading/WaitLoad.js